import React from 'react';
import { CheckIcon } from 'lucide-react';
import { site, values } from '../../data/site';
const valueAccents = ['border-brand-cyan/30 bg-brand-cyan/[0.06] text-brand-cyan', 'border-brand-blue/30 bg-brand-blue/[0.06] text-brand-blue', 'border-brand-indigo/30 bg-brand-indigo/[0.06] text-brand-indigo', 'border-brand-violet/30 bg-brand-violet/[0.06] text-brand-violet'];
export function AboutSection() {
  return <section id="about" className="w-full bg-white" data-id="element-99" data-mp="qfy2uyu7057c">
      <div className="mx-auto max-w-content px-6 py-24" data-id="element-100" data-mp="vfu5our5lqlb">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-101" data-mp="ve9e9e04ynro">
          <div className="lg:col-span-5" data-id="element-102" data-mp="1060vgxxejh55">
            <h2 className="text-3xl font-bold tracking-tight text-navy-800 sm:text-4xl" data-id="element-103" data-mp="1072i7zns5s2p">
              About Atlas Digital Hub
            </h2>
            <span aria-hidden="true" className="mt-4 block h-1 w-16 rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet" data-id="element-104" data-mp="197iiz1d52l3v" />
          </div>

          <div className="lg:col-span-7" data-id="element-105" data-mp="1dmfdzh320k4b">
            <p className="border-l-2 border-brand-indigo/40 pl-6 text-lg leading-relaxed text-navy-600" data-id="element-106" data-mp="1dngo9jc8x2kz">
              Atlas Digital Hub is a digital publishing and e-commerce brand
              focused on creating and distributing digital products for
              educational, creative and entertainment purposes. Our business
              develops downloadable resources, printable materials, guides,
              learning tools and interactive digital content for a global
              audience.
            </p>
            <p className="mt-6 text-base leading-relaxed text-navy-500" data-id="element-107" data-mp="1sbtm6luw8vi4">
              Atlas Digital Hub is operated by {site.legalEntity}, a Wyoming
              limited liability company. The company conducts business online
              and offers digital-only products delivered electronically.
            </p>

            <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-108" data-mp="2g2z4r8s7y1w4">
              {values.map((value, index) => {
              const accent = valueAccents[index % valueAccents.length];
              return <li key={value} className={`flex items-center gap-3 rounded-xl border px-4 py-3.5 ${accent}`} data-id="element-109" data-mp="9ezwus2bxcwr" data-mpi={index}>
                    <CheckIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-110" data-mp="3vrydkq9p0t15" />
                    <span className="text-sm font-medium text-navy-700" data-id="element-111" data-mp="3ltiy5kk1387h">
                      {value}
                    </span>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}